import Vue from 'vue'
import VueRouter from 'vue-router'
import ClassView from '../views/ClassView.vue'
import ExerciseView from '../views/ExerciseView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:classId',
    name: 'class',
    component: ClassView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
